import styles from './index.module.sass';
import OrderCardAwards from '../Consultancy/Award/OrderCardAwards';
import { useTranslation } from 'react-i18next';

export default function OrderClose({ history, match, getCookie, webservice, device }) {
  const { t } = useTranslation('order');
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <OrderCardAwards>
          <div className={styles.container}>
            <i className={`material-icons `}>check_circle_outline</i>
            &nbsp;{t('closePedido')}
          </div>
        </OrderCardAwards>
      </div>
    </div>
  );
}
